import React from "react";
import moment from "moment";
import {ConnectClientDateSelector} from "./connect-client-date-selector";

interface Props {
  value?: string | null,
  initialValue?: string,
  onChange: (value: string | null) => void,
  error?: string
}

const options: {value: number, label: string, secondary?: string}[] = (
  new Array(5).fill(1).reduce((previousValue, currentValue, currentIndex) => {
    const month =  moment().add(currentIndex + 4, 'month').startOf('month');

    return [
      ...previousValue,
      {
        value: month.diff(moment().startOf('day'), "days"),
        label: month.format('MMMM'),
        secondary: month.format('L')
      }
    ];
  }, [])
)

options.push({
  value: 0,
  label: 'Custom date'
})

export const ContactedDateSelector = ({onChange, value, error, initialValue}: Props) => (
  <ConnectClientDateSelector value={value}
                             label={'Next contact date'}
                             initialValue={initialValue}
                             onChange={onChange}
                             error={error}
                             options={options}
  />
)

